export const TRACK_EMAIL_OPT_IN_INTERACTIONS =
  'TRACK_EMAIL_OPT_IN_INTERACTIONS';

export function trackEmailOptInInteractions(eventLabel) {
  return {
    type: TRACK_EMAIL_OPT_IN_INTERACTIONS,
    eventLabel,
  };
}
